import React from 'react';
import clsx from 'clsx';

import styles from './spinner.module.scss';

type LoadingProps = { color?: 'light' | 'dark'; isCentered?: boolean };

const Spinner = ({ color = 'dark', isCentered }: LoadingProps) => (
  <div className={clsx(styles.loader, styles[color], { [styles.centered]: isCentered })}>
    <div className={styles.loader__spinner} />
  </div>
);

export { Spinner };
